import { MessageNodeFieldTypeEnum } from "../../../../enum/nodes.enum";
import { z } from "zod";

export const messageNodeMediaSchema = z.object({
  type: z.literal(MessageNodeFieldTypeEnum.MEDIA),
  fileUrl: z.string().optional(),
  customUrl: z.string().url().optional(),
  fileType: z.string().optional(),
});

export type MessageNodeMediaSchema = z.infer<typeof messageNodeMediaSchema>;
